module.exports = __webpack_public_path__ + "img/facebookB.edf24a90.png";